<template>
  <div class="v5-toast-region" aria-live="polite">
    <div v-if="alert.show" class="v5-toast" :class="`is-${kind}`" :role="kind === 'error' ? 'alert' : 'status'">
      <component :is="icon" class="i" aria-hidden="true" />
      <p>{{ alert.messageText }}</p>
      <button class="v5-ib" type="button" :aria-label="t('v5.shell.dismiss')" @click="store.commit('hideMessage')">
        <XMarkIcon class="i" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import {
  CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon, XMarkIcon,
} from '@heroicons/vue/24/outline';

// The classic AlertPopup: shows store.state.alertMessage, which pages set with
// store.commit('showMessage', { messageType, messageText }). Errors stay until dismissed.
const HIDE_AFTER_MS = 6000;
const { t } = useI18n();
const store = useStore();
const alert = computed(() => store.state.alertMessage);
const kind = computed(() => {
  const type = alert.value.messageType;
  return ['success', 'error'].includes(type) ? type : 'warning';
});
const ICONS = { success: CheckCircleIcon, error: XCircleIcon, warning: ExclamationTriangleIcon };
const icon = computed(() => ICONS[kind.value]);

let timer;
watch(() => [alert.value.show, alert.value.messageText], ([show]) => {
  clearTimeout(timer);
  if (!show || kind.value === 'error') return;
  timer = setTimeout(() => store.commit('hideMessage'), HIDE_AFTER_MS);
}, { immediate: true });
onBeforeUnmount(() => clearTimeout(timer));
</script>
